import { ProviderAuthenticationClient } from '~/plugins/data-connector/authentication/client'
import { ProviderClient } from '../../abstract/provider.client'
import { ProviderIntercomCommon } from '../common'
import { FormConnectSteps } from './FormConnectSteps'
import { FormSetupSteps } from './FormSetupSteps'

export const ProviderIntercomClient: ProviderClient = {
  key: ProviderIntercomCommon.key,
  authentication: ProviderAuthenticationClient.Oauth2({
    ...ProviderIntercomCommon.authentication,
    // inputs: [
    //   {
    //     key: 'region',
    //     inputType: 'Select',
    //     propsFormItem: {
    //       label: 'Region',
    //     },
    //     propsInput: {
    //       placeholder: 'Select a region',
    //       options: [
    //         { label: 'US', value: 'intercom' },
    //         { label: 'EU', value: 'eu.intercom' },
    //         { label: 'AU', value: 'au.intercom' },
    //       ],
    //     },
    //   },
    // ],
  }),

  description: {
    label: 'Intercom',
    icon: <i className="lab la-intercom" style={{ fontSize: '20px' }}></i>,
    triggers: [
      {
        key: 'newMessage',
        label: 'New message',
        input: [],
        output: [],
      },
    ],
    actions: [
      {
        key: 'findManyConversations',
        label: 'List conversations',
        input: [],
        output: [],
      },
      {
        key: 'findOneConversation',
        label: 'Get conversation',
        input: [],
        output: [],
      },
      {
        key: 'findManyMessagesByConversation',
        label: 'List conversation messages',
        input: [],
        output: [],
      },
      {
        key: 'sendMessage',
        label: 'New message',
        input: [],
        output: [],
      },
    ],
  },

  FormSetupSteps,
  FormConnectSteps,
}
